module.exports = __webpack_public_path__ + "img/tertiary_11x4.64d406be.svg";